import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import { Link } from 'react-router';
import Api, { Utils } from '../Api';

const marketplaceImageWidth = 236;
const marketplaceImageHeight = 260;
const marketplaceImageAspectRatio = marketplaceImageWidth / marketplaceImageHeight;

export default class MarketplaceProduct extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    product: PropTypes.object.isRequired,
    brand: PropTypes.object.isRequired,
    retailerToken: PropTypes.string,
    onClick: PropTypes.func,
    onBrandClick: PropTypes.func,
    brandUrl: PropTypes.string,
    onImageLoad: PropTypes.func,
    imageLoadDelay: PropTypes.number,
    isEmployee: PropTypes.bool,
    cartEntry: PropTypes.array
  };

  constructor(props) {
    super(props);

    Utils.bindThis(
      this,
      [
        'adminPanel',
        'onImageLoad',
        'imageList',
        'heartsPanel',
        'wholesaleInfo',
        'extraContent',
        'onProductClick',
        'onBrandClick',
        'onAdminClick',
        'onActiveClick',
        'onManualRecommendationClick'
      ]
    );

    this.state = {
      product: props.product,
      brand: props.brand
    };
  }

  componentWillMount() {
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      product: nextProps.product
    });
  }

  displayBrandBlock() {
    return true;
  }

  onImageLoad() {
    if (this.props.onImageLoad) {
      let delay = this.props.imageLoadDelay || 0;
      setTimeout(() => {
        this.props.onImageLoad(this)
      }, delay);
    }
  }

  imageList(product) {
    let imageList = [];
    if (product.images) {
      product.images.forEach(image => {
        imageList.push(image);
      });
    }

    if (product.options) {
      product.options.forEach(productOption => {
        if (!productOption.images) return;

        productOption.images.forEach(image => {
          imageList.push(image);
        });
      });
    }

    return imageList;
  }

  onProductClick(event) {
    if (!this.props.onClick || event.defaultPrevented) return;

    event.preventDefault();
    this.props.onClick(this.state.product);
  }

  onBrandClick(event) {
    if (!this.props.onBrandClick || event.defaultPrevented) return;

    event.preventDefault();
    this.props.onBrandClick(this.props.brand);
  }

  onAdminClick(event) {
    event.preventDefault();
  }

  onActiveClick(event) {
    event.preventDefault();

    let product = this.state.product;
    product.active = !product.active;
    return Api.saveProduct(product).then(
      () => {
        this.setState({product: product});
      },
      (error) => {
        alert(error.response.message);
      }
    );
  }

  onManualRecommendationClick(event) {
    event.preventDefault();

    let retailerToken = this.props.retailerToken;
    if (!retailerToken) return;

    let product = this.state.product;
    let manualRecommendation = product.manual_recommendation;
    let promise = null;
    if (manualRecommendation) {
      promise = Api.retailerRemoveRecommendation(retailerToken, product.token);
    } else {
      promise = Api.retailerAddRecommendation(retailerToken, product.token);
    }

    return promise.then(
      () => {
        product.manual_recommendation = !manualRecommendation;
        this.setState({product: product});
      },
      (error) => {
        alert(error.response.message);
      }
    );
  }

  heartsPanel() {
    let hearts = null;
    let totalLikes = this.state.product.likes || this.props.brand.likes;
    if (totalLikes) {
      if (totalLikes > 1000000) {
        totalLikes = parseFloat(totalLikes / 1000000).toFixed(0) + 'M';
      } else if (totalLikes > 1000) {
        totalLikes = parseFloat(totalLikes / 1000).toFixed(0) + 'k';
      }

      hearts = <div className="hearts">{totalLikes} <FontAwesome name="heart"/></div>
    }

    return hearts;
  }

  adminPanel() {
    let admin = null;
    if (this.props.isEmployee) {
      let isActive = !!this.state.product.active;

      let isManualRecommendation = !!this.state.product.manual_recommendation;
      let manualRecommendation = (
        <p>
          <span onClick={this.onManualRecommendationClick}>Manual recommendation</span>
          <input className="checkbox inline"
                 type="checkbox"
                 style={{cursor: 'pointer'}}
                 onChange={this.onManualRecommendationClick}
                 checked={isManualRecommendation} />
        </p>
      );

      let recommenderNames = null;
      if (this.state.product.recommenders) {
        // Make sure the elements are unique and remove manual as it's displayed separately above.
        let recommendationSet = new Set(this.state.product.recommenders);
        recommendationSet.delete('MANUAL');
        recommenderNames = <p><span>{Array.from(recommendationSet).join(', ')}</span></p>;
      }

      let likesAndCreationYear = null;
      if (this.state.brand) {
        let totalLikes = this.state.brand.likes || '-';
        if (totalLikes >= 1000000) {
          totalLikes = parseFloat(totalLikes / 1000000).toFixed(0) + 'M';
        } else if (totalLikes >= 1000) {
          totalLikes = parseFloat(totalLikes / 1000).toFixed(0) + 'K';
        }
        let established = this.state.brand.creation_year || '-';
        likesAndCreationYear = <div>{totalLikes}<FontAwesome name="heart"/> Established: {established}</div>
      }

      admin = (
        <div className="admin" onClick={this.onAdminClick}>
          <p>
            <span onClick={this.onActiveClick}>Active</span>
            <input className="checkbox inline"
                   type="checkbox"
                   style={{cursor: 'pointer'}}
                   onChange={this.onActiveClick}
                   checked={isActive} />
          </p>
          {manualRecommendation}
          {recommenderNames}
          {likesAndCreationYear}
        </div>
      );
    }

    return admin;
  }

  wholesaleInfo() {
    let product = this.state.product;
    let productOption = (product.options && product.options.length > 0) ? product.options[0] : {
      unit_multiplier: 1,
      wholesale_price_cents: null
    };

    let unitMultiplier = productOption.unit_multiplier;
    let retailPrice = productOption.retail_price_cents ? '$' + Utils.formatCents(productOption.retail_price_cents, true) : null;
    let wholesalePrice = productOption.wholesale_price_cents ? '$' + Utils.formatCents(productOption.wholesale_price_cents, true) : null;

    return {
      wholesale_price: wholesalePrice,
      retail_price: retailPrice,
      unit_multiplier: unitMultiplier,
      collection_size: null,
    };
  }

  extraContent() {
    if (this.props.cartEntry) {
      let quantity = 0;
      this.props.cartEntry.forEach(entry => {
        quantity += entry.quantity;
      });
      return (
        <div className="cart-contents">
          <div className="edit-icon"><FontAwesome name="pencil" /></div>
          <div className="title">Added to Bag</div>
          <div className="quantity">Qty: {quantity} items</div>
        </div>
      );
    }
    return null;
  }

  render() {
    if (!this.state.product) return null;

    if (!this.props.brand) {
      console.error("Where's my brand?");
      console.error(this.state.product);

      return null;
    }

    let product = this.state.product;

    let minimumOrder = this.props.brand.minimum_order_amount_cents;
    if (minimumOrder) {
      minimumOrder = 'Minimum $' + parseFloat(minimumOrder / 100).toFixed(0);
    }

    if (!minimumOrder) {
      minimumOrder = 'No minimum';
    }

    let wholesaleData = this.wholesaleInfo();
    let retailContents =
      <div className="outer-wrapper">
        <div className="inner-wrapper">
          <div className="retail-price">{wholesaleData.retail_price && "Retail Price " + wholesaleData.retail_price}</div>
          <div className="case-size">
            {wholesaleData.collection_size && wholesaleData.collection_size + ' Items'}
            {wholesaleData.unit_multiplier && 'Case Size ' + wholesaleData.unit_multiplier}
          </div>
        </div>
      </div>;

    let brandBlock = null;
    if (this.displayBrandBlock()) {
      brandBlock =
        <Link className="brand-block" to={this.props.brandUrl}>
          <div className="maker">Maker</div>
          <div className="brand-info-contents">
            <h3 className="name">{this.props.brand.name}</h3>
            <div className="minimum">{minimumOrder}</div>
          </div>
        </Link>;
    } else {
      brandBlock = <Link className="brand-block blank" />;
    }

    let productError = false;
    if (!this.state.product.items) {
      productError = !this.state.product || !this.state.product.options || this.state.product.options.length <= 0;
    }

    let classNames = [ 'marketplace-product' ];
    if (productError) {
      classNames.push('product-error');
    }

    if (productError && !this.props.isEmployee) {
      return null;
    }

    if (this.props.className) classNames.push(this.props.className);

    return (
      <div className={classNames.join(' ')} onClick={this.onProductClick}>
        <div className="product-block">
          <MarketplaceImage imageList={this.imageList(product)} />
          {this.extraContent()}
          <div className="retail-overlay">{retailContents}</div>
          <div className="product-line line flex">
            <h2 className="product-name inline">{product.name}</h2>
            <div className="wholesale-price">{wholesaleData.wholesale_price}</div>
          </div>
        </div>
        {brandBlock}
        {this.adminPanel()}
      </div>
    );
  }
}

const MarketplaceImage = ({ imageList }) => {
  if (!Array.isArray(imageList) || imageList.length === 0) return <div className="image no-image" />;
  let image = imageList[0];

  let classNames = [ 'image' ];
  if (image.width && image.height) {
    let aspectRatio = image.width / image.height;

    if (aspectRatio > marketplaceImageAspectRatio) {
      classNames.push('landscape');
    } else if (aspectRatio < marketplaceImageAspectRatio) {
      classNames.push('portrait');
    }
  }

  return (
    <div className={classNames.join(' ')}>
      <img
        role="presentation"
        src={image.url}
      />
    </div>
  );
};



/** WEBPACK FOOTER **
 ** ./src/views/MarketplaceProduct.js
 **/